<script lang="ts">
  import { domId } from "../lib/dom";
  import Form from "../components/Form.svelte";
  import SignatureInput from "../components/SignatureInput.svelte";

  let {
    title,
    action,
    contact_link,
    client_info,
    preview_links,
    errors
  }: {
    title: string;
    action: string;
    contact_link: string;
    client_info: {
      full_name: string;
      former_name: string;
      date_of_birth: string;
      address_lines: string[];
    };
    preview_links: string[][];
    errors: { [key: string]: string } | null;
  } = $props();

  const closeDialogId = domId("close-dialog");
</script>

<Form method="put" {action} class="ui-rhythm">
  <h2 class="ui-title">{title}</h2>

  <p>Finance companies require us to periodically obtain a new signature on your Form of Authority to ensure we are still acting on your behalf. Without a fresh signature, your finance company may refuse to progress your case, delaying or possibly denying you compensation.</p>

  <h3 class="ui-section-title">Step 1: Review your information</h3>
  <p>If any of the following require correction or updating, stop here and <a href={contact_link} class="link-primary" data-turbo-frame="_top">contact us</a> straight away. If you have multiple claims, you need only contact us once to update all of them.</p>
  <table class="table table-sm">
    <tbody>
      <tr><th class="align-top">Full name</th><td class="align-top">{client_info.full_name}</td></tr>
      <tr><th class="align-top">Former name</th><td class="align-top">{client_info.former_name}</td></tr>
      <tr><th class="align-top">Date of birth</th><td class="align-top">{client_info.date_of_birth}</td></tr>
      <tr><th class="align-top">Address</th><td class="align-top">
        {#each client_info.address_lines as line}
          <div>{line}</div>
        {/each}
      </td></tr>
    </tbody>
  </table>

  <h3 class="ui-section-title">Step 2: Sign form</h3>

  <p class="mb-2">Please review the sample {preview_links.length > 1 ? "documents" : "document"} below, then sign to renew your agreement.</p>

  <ul class="ui-list">
    {#each preview_links as [documentTitle, href]}
      <li><a {href} target="_blank" class="link-primary">{documentTitle}</a></li>
    {/each}
  </ul>

  <p class="font-medium">Your signature will be applied to the Form of Authority for all your mis-sold finance claims being handled by Johnson Law Group.</p>

  <fieldset>
    <div class="-mx-1">
      <SignatureInput required name="signature" />
    </div>
    {#if errors?.signature}<div class="ui-error">{errors.signature}</div>{/if}
  </fieldset>

  {#if errors?.general}<div class="ui-error">{errors.general}</div>{/if}

  <div class="floating-footer">
    <button class="btn btn-ghost" form={closeDialogId}>Cancel</button>
    <button class="btn btn-primary" type="submit">Done</button>
  </div>
</Form>

<form method="dialog" id={closeDialogId}></form>
